// src/layouts/DrawerNavigation.js
import React, { useState } from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Box
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { auth } from '../firebase'; // If you need logout functionality
import './DrawerNavigation.css';    // We'll style some MUI components

function DrawerNavigation() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleLogout = async () => {
    await auth.signOut();
    navigate('/login');
  };

  const drawerItems = [
    { text: 'Home', path: '/home' },
    { text: 'Profile', path: '/profile' },
    { text: 'OBL Team', path: '/team' },
    { text: 'Journalist Search', path: '/journalist-search' },
    { text: 'Friends Search', path: '/friends-search' },
    { text: 'Topic Search', path: '/topic-search' },
    { text: 'Submit', path: '/submit' },
    { text: 'Direct Messages', path: '/direct-messages' },
  ];

  const drawer = (
    <Box
      sx={{ width: 250, backgroundColor: '#003756', height: '100%' }}
      role="presentation"
      onClick={handleDrawerToggle}
      onKeyDown={handleDrawerToggle}
    >
      <List>
        {drawerItems.map((item) => (
          <ListItemButton
            key={item.text}
            component={Link}
            to={item.path}
            sx={{
              color: '#fff',
              '&:hover': {
                backgroundColor: '#BE2329', // red highlight on hover
              },
            }}
          >
            <ListItemText primary={item.text} />
          </ListItemButton>
        ))}
        <ListItemButton
          onClick={handleLogout}
          sx={{
            color: '#fff',
            '&:hover': {
              backgroundColor: '#BE2329',
            },
          }}
        >
          <ListItemText primary="Log Out" />
        </ListItemButton>
      </List>
    </Box>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      {/* Top AppBar */}
      <AppBar position="fixed" sx={{ backgroundColor: '#003756' }}>
        <Toolbar>
          {/* Hamburger Icon */}
          <IconButton
            color="inherit"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div">
            Operation Border Lights
          </Typography>
        </Toolbar>
      </AppBar>

      {/* The actual Drawer */}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={handleDrawerToggle}
      >
        {drawer}
      </Drawer>

      {/* Page content is rendered here */}
      <Box component="main" sx={{ flexGrow: 1, p: 3, mt: 8 }}>
        <Outlet />
      </Box>
    </Box>
  );
}

export default DrawerNavigation;
